import React, { createContext, useContext, useState } from "react";

const AllDataContext = createContext({
  allData: {},
  setAllData: () => {},
});

export const useAllDataContext = () => useContext(AllDataContext);

export const AllDataProvider = ({ children }) => {
  const [allData, setAllData] = useState({
    sliderData: [],
    tilesHeaderData: [],
    tilesData: [],
    aboutData: [],
    chairmenData: [],
    chooseUsData: [],
    highlightsData: [], 
    testimonialHeaderData: [],
    testimoniaData: [],
    facultyHeaderData: [],
    facultyMemberData: [],
    facilitiesData: [],
    activitiesData: [],
    galleryHeaderData: [],
    galleryImagesData: [],
    bannerData: [],
    visionObjectiveHeaderData: [],
    visionData: [],
    objectiveData: [],
    whyEgaData: [],
    certificateHeaderData: [],
    certificateListData: [],
    joinCommunityHeaderData: [],
    contactHeaderData: [],
    contactFormHeaderData: [],
    policiesData: [],
    calendarData: [],
    allBannerData: [],
  });

  return (
    <AllDataContext.Provider value={{ allData, setAllData }}>
      {children}
    </AllDataContext.Provider>
  );
};
